// IE Hub - UI Constants
// Shared UI strings and configuration constants

export const UI_MESSAGES = {
  CHARACTER_LIMIT_REACHED: "The character limit has been reached.",
  APOSTROPHE_NOT_ALLOWED: "Single inverted comma (') is not allowed",
  CREDIT_CARD_4_DIGIT_ALERT: "Credit card account numbers should be the last 4 digits only. Please check and enter the last 4 digits",
  CREDIT_CARD_4_DIGIT_HINT: "For credit cards, this is often the last 4 digits of your card or account number.",
};
